import { DEFAULT_VOICE_LOUDNESS_CONFIG, MONITOR_TYPES } from '../types';
import VoiceLoudness from './VoiceLoudness';
import VoiceLoudnessBuilderConfig from './VoiceLoudness/BuilderConfig';
import { createVoiceLoudnessController } from './VoiceLoudness/controller';
import VoiceLoudnessSelectorPreview from './VoiceLoudness/SelectorPreview';
import { V2_STIMULUS_PROGRESSION, V2_STIMULUS_RENDERER } from './types';
import { V2_PRODUCTION_BOUNDARY, V2_REPETITION_BOUNDARY } from './runtime/types';

export const V2_MONITOR_REGISTRY = {
  [MONITOR_TYPES.VOICE_LOUDNESS]: {
    version: 2,
    titleKey: 'UI.voiceLoudness',
    defaultConfig: DEFAULT_VOICE_LOUDNESS_CONFIG,
    BuilderComponent: VoiceLoudnessBuilderConfig,
    RuntimeComponent: VoiceLoudness,
    SelectorComponent: VoiceLoudnessSelectorPreview,
    createController: createVoiceLoudnessController,
    stimulusPolicy: {
      progression: V2_STIMULUS_PROGRESSION.MANUAL,
      renderer: V2_STIMULUS_RENDERER.MAIN_UI,
    },
    productionPolicy: {
      repetitionBoundary: V2_REPETITION_BOUNDARY.MANUAL_NEXT,
      productionBoundary: V2_PRODUCTION_BOUNDARY.REPETITIONS_COMPLETE,
    },
    resultPolicy: {
      usesMastery: false,
      saveRepetitions: true,
      saveProductions: true,
      saveExerciseSummary: true,
    },
    requiresMicrophone: true,
    formatOverview: (config) => `${config.targetLowDbfs} - ${config.targetHighDbfs} dBFS`,
  },
};
